<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-card style="width: 700px">
            <!--<v-responsive :aspect-ratio="16 / 9">-->
            <v-card-title primary-title>
              <div>
                <div class="headline ps-2 pa-1">{{ $t("settingsPage.generalTitle") }}</div>
              </div>
            </v-card-title>
            <v-flex>
              <v-form ref="form" v-model="form" class="pa-4 pt-6">

                <label style="font-size: large">{{ $t("settingsPage.bookingProposalTimeSeconds") }}</label>
                <v-text-field outline v-model="model.CAPTAIN_SUGGESTION_TIME" :rules="[rules.required, rules.number]"
                  :label="$t('settingsPage.bookingProposalTime')" type="text"
                  style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.minReservationMinutes") }}</label>
                <v-text-field outline v-model="model.MINIMUM_RESERVATION" :rules="[rules.required, rules.number]"
                  :label="$t('settingsPage.minReservationMinutes')" type="text"
                  style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.minDistanceMeters") }}</label>
                <v-text-field outline v-model="model.MIN_DISTANCE_TO_PLACE_REQUEST_IN_METERS"
                  :rules="[rules.required, rules.number]" :label="$t('settingsPage.minDistance')" type="text"
                  style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.allowedWaitingTimeMin") }}</label>
                <v-text-field outline v-model="model.NORMAL_ALLOWED_WAITING_TIME" :label="$t('settingsPage.allowedWaitingTime')"
                  :rules="[rules.required, rules.number]" type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.exchangeRate") }}</label>
                <v-text-field outline v-model="model.EXCHANGE_RATE" :label="$t('settingsPage.exchangeRate')" type="text"
                  :rules="[rules.required, rules.number]" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.maxSearchSpaceKm") }}</label>
                <v-text-field outline v-model="model.INSTANT_MAX_DISPATCH_DISTANCE" :label="$t('settingsPage.maxSearchSpace')"
                  :rules="[rules.required, rules.number]" type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.dispatchMode") }}</label>
                <v-select outline v-model="model.DISPATCH_MODE" :items="['SEQUENTIAL', 'HYBRID']"
                  :label="$t('settingsPage.dispatchModeHint')" style="margin-top: 15px"></v-select>

                <label style="font-size: large">{{ $t("settingsPage.hybridBroadcastAfterSec") }}</label>
                <v-text-field outline v-model="model.HYBRID_BROADCAST_AFTER"
                  :rules="[rules.required, rules.number]" :label="$t('settingsPage.hybridBroadcastAfter')" type="text"
                  style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.broadcastBatchSize") }}</label>
                <v-text-field outline v-model="model.DISPATCH_BROADCAST_BATCH_SIZE"
                  :rules="[rules.required, rules.number]" :label="$t('settingsPage.broadcastBatchSize')" type="text"
                  style="margin-top: 15px"></v-text-field>

                <!-- Final-version doc 2026-10-05 (dormant): stop re-offering the
                     same instant order to a captain who ignored it N times
                     (DISPATCH_MAX_NO_RESPONSE_OFFERS); 0 = no limit. -->
                <label style="font-size: large">{{ $t("settingsPage.dispatchMaxNoResponseOffers") }}</label>
                <v-text-field outline v-model="model.DISPATCH_MAX_NO_RESPONSE_OFFERS" :rules="[rules.wholeNumber]"
                  :label="$t('settingsPage.dispatchMaxNoResponseOffers')"
                  :hint="$t('settingsPage.dispatchMaxNoResponseOffersHint')" persistent-hint type="text"
                  style="margin-top: 15px"></v-text-field>

                <!-- S1: kill switch for the specific-driver release (TARGET_CAPTAIN_FALLBACK). -->
                <v-switch v-model="targetCaptainFallback" :label="$t('settingsPage.targetCaptainFallback')"
                  :hint="$t('settingsPage.targetCaptainFallbackHint')" persistent-hint color="green"
                  style="margin-top: 15px"></v-switch>

                <label style="font-size: large">{{ $t("settingsPage.instantTimeToCancelMin") }}</label>
                <v-text-field outline v-model="model.INSTANT_TIME_TO_CANCELL" :label="$t('settingsPage.instantTimeToCancel')"
                  :rules="[rules.required, rules.number]" type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.reservationTimeToCancelMin") }}</label>
                <v-text-field outline v-model="model.RESERVATION_TIME_TO_CANCELL"
                  :rules="[rules.required, rules.number]" :label="$t('settingsPage.reservationTimeToCancel')" type="text"
                  style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.reservationDispatchStartTimeMin") }}</label>
                <v-text-field outline v-model="model.RESERVATION_DISPATCH_START_TIME"
                  :rules="[rules.required, rules.number]" :label="$t('settingsPage.reservationDispatchStartTime')" type="text"
                  style="margin-top: 15px"></v-text-field>

                <!-- QA V4 W1 (#08): reservation reminder cadence + confirmation. -->
                <v-divider class="my-4"></v-divider>
                <h3 class="mb-2">{{ $t("settingsPage.reservationSectionTitle") }}</h3>

                <label style="font-size: large">{{ $t("settingsPage.reservationReminderCadence") }}</label>
                <v-text-field outline v-model="model.RESERVATION_REMINDER_CADENCE" :rules="[rules.csvNumbers]"
                  :label="$t('settingsPage.reservationReminderCadence')"
                  :hint="$t('settingsPage.reservationReminderCadenceHint')" persistent-hint type="text"
                  style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.reservationConfirmDeadline") }}</label>
                <v-text-field outline v-model="model.RESERVATION_CONFIRM_DEADLINE" :rules="[rules.required, rules.number]"
                  :label="$t('settingsPage.reservationConfirmDeadlineMin')" type="text"
                  style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.reservationSuggestionTime") }}</label>
                <v-text-field outline v-model="model.RESERVATION_SUGGESTION_TIME" :rules="[rules.numberOrEmpty]"
                  :label="$t('settingsPage.reservationSuggestionTime')"
                  :hint="$t('settingsPage.reservationSuggestionTimeHint')" persistent-hint type="text"
                  style="margin-top: 15px"></v-text-field>

                <v-switch v-model="reservationConfirmRequired" :label="$t('settingsPage.reservationConfirmRequired')"
                  :hint="$t('settingsPage.reservationConfirmRequiredHint')" persistent-hint color="green"
                  style="margin-top: 15px"></v-switch>

                <!-- QA V4 W7 (#28): upfront (locked) pricing controls. -->
                <v-divider class="my-4"></v-divider>
                <h3 class="mb-2">{{ $t("settingsPage.pricingSectionTitle") }}</h3>

                <v-switch v-model="upfrontPricingEnabled" :label="$t('settingsPage.upfrontPricingEnabled')"
                  :hint="$t('settingsPage.upfrontPricingEnabledHint')" persistent-hint color="green"
                  style="margin-top: 15px"></v-switch>

                <label style="font-size: large">{{ $t("settingsPage.extraKmTolerancePct") }}</label>
                <v-text-field outline v-model="model.EXTRA_KM_TOLERANCE_PCT" :rules="[rules.required, rules.number]"
                  :label="$t('settingsPage.extraKmTolerancePct')" :hint="$t('settingsPage.extraKmTolerancePctHint')"
                  persistent-hint type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.maxFareIncreasePct") }}</label>
                <v-text-field outline v-model="model.MAX_FARE_INCREASE_PCT" :rules="[rules.required, rules.number]"
                  :label="$t('settingsPage.maxFareIncreasePct')" :hint="$t('settingsPage.maxFareIncreasePctHint')"
                  persistent-hint type="text" style="margin-top: 15px"></v-text-field>

                <!-- Kill switch (FARE_DISTANCE_GUARD_ENABLED) for the billed-distance
                     guard: no estimate billed for a ride that never moved, and
                     no distance beyond what the ride's duration allows. -->
                <v-switch v-model="fareDistanceGuardEnabled" :label="$t('settingsPage.fareDistanceGuardEnabled')"
                  :hint="$t('settingsPage.fareDistanceGuardEnabledHint')" persistent-hint color="green"
                  style="margin-top: 15px"></v-switch>

                <!-- QA V4: staging-only safety allow-list (no effect on production). -->
                <v-divider class="my-4"></v-divider>

                <label style="font-size: large">{{ $t("settingsPage.stagingAllowedPhones") }}</label>
                <v-text-field outline v-model="model.STAGING_ALLOWED_PHONES"
                  :label="$t('settingsPage.stagingAllowedPhones')"
                  :hint="$t('settingsPage.stagingAllowedPhonesHint')" persistent-hint type="text"
                  style="margin-top: 15px"></v-text-field>

                <!--
                  Commission percentages were moved to the Services page
                  (per-service Company/Driver/Owner %). The old global
                  Snap/External/Car-Owner commission settings are no longer
                  used by the commission engine and were removed to avoid
                  confusion (two places for the same thing).
                -->

                <label style="font-size: large">{{ $t("settingsPage.maxNegativeAmountSyp") }}</label>
                <v-text-field outline v-model="model.CAPTAIN_MAX_NEGARIVE_AMOUNT"
                  :rules="[rules.required, rules.number]" :label="$t('settingsPage.maxNegativeAmount')" type="text"
                  style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.snapPhone") }}</label>
                <v-text-field outline v-model="model.SNAP_DRIVE_PHONE" :label="$t('settingsPage.snapPhone')" type="text"
                  :rules="[rules.required, rules.number]" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.snapEmail") }}</label>
                <v-text-field outline v-model="model.SNAP_DRIVE_EMAIL" :label="$t('settingsPage.snapEmail')" type="text"
                  :rules="[rules.required, rules.email]" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.snapWhatsapp") }}</label>
                <v-text-field outline v-model="model.SNAP_DRIVE_WHATSAPP" :label="$t('settingsPage.snapWhatsapp')" type="text"
                  :rules="[rules.required, rules.number]" style="margin-top: 15px"></v-text-field>

                <v-text-field outline v-model="model.CALL_CENTER_NUMBER" label="Call Center Number (Passenger)" type="text"
                  :rules="[rules.phone]" style="margin-top: 15px"
                  hint="Passenger-app support button; leave empty to keep the app's built-in fallback number"
                  persistent-hint></v-text-field>

                <v-text-field outline v-model="model.CAPTAIN_CALL_CENTER_NUMBER" label="Call Center Number (Captain)" type="text"
                  :rules="[rules.phone]" style="margin-top: 15px"
                  hint="Captain-app support button; a separate line from the passenger call center"
                  persistent-hint></v-text-field>

                <v-switch v-model="safeRideEnabled" :label="$t('settingsPage.safeRideEnabled')"
                  :hint="$t('settingsPage.safeRideEnabledHint')" persistent-hint color="green"
                  style="margin-top: 15px"></v-switch>

                <!-- Rendered Static Maps image in the captain's accept window
                     (PROPOSAL_STATIC_MAP_ENABLED): a separately billed Google
                     SKU, so ops must be able to switch the spend off here. -->
                <v-switch v-model="proposalStaticMapEnabled" :label="$t('settingsPage.proposalStaticMapEnabled')"
                  :hint="$t('settingsPage.proposalStaticMapEnabledHint')" persistent-hint color="green"
                  style="margin-top: 15px"></v-switch>

                <!-- Kill switch (CAPTAIN_REROUTE_ENABLED) for the live route the
                     captain app asks for when the car leaves the drawn line. -->
                <v-switch v-model="captainRerouteEnabled" :label="$t('settingsPage.captainRerouteEnabled')"
                  :hint="$t('settingsPage.captainRerouteEnabledHint')" persistent-hint color="green"
                  style="margin-top: 15px"></v-switch>

                <!-- Owner item 3.1: the activity windows behind the Active /
                     Inactive filter of the drivers and riders lists. -->
                <v-divider class="my-4"></v-divider>
                <h3 class="mb-2">{{ $t("settingsPage.accountActivitySection") }}</h3>

                <label style="font-size: large">{{ $t("settingsPage.captainActivityWindowDays") }}</label>
                <v-text-field outline v-model="model.CAPTAIN_ACTIVITY_WINDOW_DAYS" :rules="[rules.required, rules.wholeDays]"
                  :label="$t('settingsPage.captainActivityWindowDays')"
                  :hint="$t('settingsPage.captainActivityWindowDaysHint')" persistent-hint type="text"
                  style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.passengerActivityWindowDays") }}</label>
                <v-text-field outline v-model="model.PASSENGER_ACTIVITY_WINDOW_DAYS" :rules="[rules.required, rules.wholeDays]"
                  :label="$t('settingsPage.passengerActivityWindowDays')"
                  :hint="$t('settingsPage.passengerActivityWindowDaysHint')" persistent-hint type="text"
                  style="margin-top: 15px"></v-text-field>

                <!-- Welcome bonus for newly approved captains (doc 28-8 §4.2). -->
                <v-divider class="my-4"></v-divider>
                <h3 class="mb-2">{{ $t("settingsPage.welcomeBonusSection") }}</h3>

                <v-switch v-model="welcomeBonusEnabled" :label="$t('settingsPage.welcomeBonusEnabled')"
                  :hint="$t('settingsPage.welcomeBonusEnabledHint')" persistent-hint color="green"
                  style="margin-top: 15px"></v-switch>

                <template v-if="welcomeBonusEnabled">
                  <label style="font-size: large">{{ $t("settingsPage.welcomeBonusDefault") }}</label>
                  <v-text-field outline v-model="welcomeBonusDefaultDisplay" :rules="[rules.number]"
                    :label="$t('settingsPage.welcomeBonusDefault')" :hint="$t('settingsPage.welcomeBonusDefaultHint')"
                    persistent-hint type="text" style="margin-top: 15px"></v-text-field>

                  <!-- Owner item 2.1: validity and ceiling of new grants. -->
                  <label style="font-size: large">{{ $t("settingsPage.welcomeBonusValidityDays") }}</label>
                  <v-text-field outline v-model="model.CAPTAIN_WELCOME_BONUS_VALIDITY_DAYS"
                    :rules="[rules.wholeNumber]" :label="$t('settingsPage.welcomeBonusValidityDays')"
                    :hint="$t('settingsPage.welcomeBonusValidityDaysHint')" persistent-hint type="text"
                    style="margin-top: 15px"></v-text-field>

                  <label style="font-size: large">{{ $t("settingsPage.welcomeBonusMax") }}</label>
                  <v-text-field outline v-model="welcomeBonusMaxDisplay" :rules="[rules.number]"
                    :label="$t('settingsPage.welcomeBonusMax')" :hint="$t('settingsPage.welcomeBonusMaxHint')"
                    persistent-hint type="text" style="margin-top: 15px"></v-text-field>
                </template>

                <!-- Owner item 2.1: closing a balance already granted is possible
                     with the grant switch off too, so this one always shows. -->
                <label style="font-size: large">{{ $t("settingsPage.welcomeBonusMateriality") }}</label>
                <v-text-field outline v-model="welcomeBonusMaterialityDisplay" :rules="[rules.number]"
                  :label="$t('settingsPage.welcomeBonusMateriality')"
                  :hint="$t('settingsPage.welcomeBonusMaterialityHint')" persistent-hint type="text"
                  style="margin-top: 15px"></v-text-field>

                <!-- Operational entries doc 2026-10-03, items 1.3/1.4/1.6:
                     gateway receipts only on a confirmed payment. -->
                <v-divider class="my-4"></v-divider>
                <h3 class="mb-2">{{ $t("settingsPage.onlinePaymentsSection") }}</h3>

                <label style="font-size: large">{{ $t("settingsPage.onlinePaymentPendingWaitMinutes") }}</label>
                <v-text-field outline v-model="model.ONLINE_PAYMENT_PENDING_WAIT_MINUTES" :rules="[rules.wholeNumber]"
                  :label="$t('settingsPage.onlinePaymentPendingWaitMinutes')"
                  :hint="$t('settingsPage.onlinePaymentPendingWaitMinutesHint')" persistent-hint type="text"
                  style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.onlineUnconfirmedCaptainSettle") }}</label>
                <v-select outline v-model="model.ONLINE_UNCONFIRMED_CAPTAIN_SETTLE" :items="onlineUnconfirmedSettleItems"
                  item-text="text" item-value="value" :label="$t('settingsPage.onlineUnconfirmedCaptainSettle')"
                  :hint="$t('settingsPage.onlineUnconfirmedCaptainSettleHint')" persistent-hint
                  style="margin-top: 15px"></v-select>

                <label style="font-size: large">{{ $t("settingsPage.unpaidOnlineRideAfterHours") }}</label>
                <v-text-field outline v-model="model.UNPAID_ONLINE_RIDE_AFTER_HOURS" :rules="[rules.wholeNumber]"
                  :label="$t('settingsPage.unpaidOnlineRideAfterHours')"
                  :hint="$t('settingsPage.unpaidOnlineRideAfterHoursHint')" persistent-hint type="text"
                  style="margin-top: 15px"></v-text-field>

                <v-switch v-model="walletRequireBalanceAtBooking" :label="$t('settingsPage.walletRequireBalanceAtBooking')"
                  :hint="$t('settingsPage.walletRequireBalanceAtBookingHint')" persistent-hint color="green"
                  style="margin-top: 15px"></v-switch>

                <!-- Accountant doc 2026-10-03 item 1.5: automatic compensation
                     paid to the driver when the passenger cancels after he
                     started toward the pickup. -->
                <v-divider class="my-4"></v-divider>
                <h3 class="mb-2">{{ $t("settingsPage.cancellationCompensationSection") }}</h3>

                <v-switch v-model="cancellationCompensationEnabled" :label="$t('settingsPage.cancellationCompensationEnabled')"
                  :hint="$t('settingsPage.cancellationCompensationEnabledHint')" persistent-hint color="green"
                  style="margin-top: 15px"></v-switch>

                <template v-if="cancellationCompensationEnabled">
                  <label style="font-size: large">{{ $t("settingsPage.cancellationCompensationPerKm") }}</label>
                  <v-text-field outline v-model="cancellationCompensationPerKmDisplay" :rules="[rules.number]"
                    :label="$t('settingsPage.cancellationCompensationPerKm')"
                    :hint="$t('settingsPage.cancellationCompensationPerKmHint')" persistent-hint type="text"
                    style="margin-top: 15px"></v-text-field>

                  <label style="font-size: large">{{ $t("settingsPage.cancellationCompensationFreeKm") }}</label>
                  <v-text-field outline v-model="model.CANCELLATION_COMPENSATION_FREE_KM" :rules="[rules.number]"
                    :label="$t('settingsPage.cancellationCompensationFreeKm')"
                    :hint="$t('settingsPage.cancellationCompensationFreeKmHint')" persistent-hint type="text"
                    style="margin-top: 15px"></v-text-field>

                  <label style="font-size: large">{{ $t("settingsPage.cancellationCompensationRounding") }}</label>
                  <v-select outline v-model="model.CANCELLATION_COMPENSATION_ROUNDING" :items="compensationRoundingItems"
                    :label="$t('settingsPage.cancellationCompensationRounding')"
                    :hint="$t('settingsPage.cancellationCompensationRoundingHint')" persistent-hint
                    style="margin-top: 15px"></v-select>

                  <label style="font-size: large">{{ $t("settingsPage.cancellationCompensationMaxKm") }}</label>
                  <v-text-field outline v-model="model.CANCELLATION_COMPENSATION_MAX_KM" :rules="[rules.number]"
                    :label="$t('settingsPage.cancellationCompensationMaxKm')"
                    :hint="$t('settingsPage.cancellationCompensationMaxKmHint')" persistent-hint type="text"
                    style="margin-top: 15px"></v-text-field>

                  <label style="font-size: large">{{ $t("settingsPage.cancellationCompensationTolerance") }}</label>
                  <v-text-field outline v-model="model.CANCELLATION_COMPENSATION_DISTANCE_TOLERANCE_PCT" :rules="[rules.number]"
                    :label="$t('settingsPage.cancellationCompensationTolerance')"
                    :hint="$t('settingsPage.cancellationCompensationToleranceHint')" persistent-hint type="text"
                    style="margin-top: 15px"></v-text-field>

                  <label style="font-size: large">{{ $t("settingsPage.cancellationCompensationArrivedRadius") }}</label>
                  <v-text-field outline v-model="model.CANCELLATION_COMPENSATION_ARRIVED_RADIUS_M" :rules="[rules.number]"
                    :label="$t('settingsPage.cancellationCompensationArrivedRadius')"
                    :hint="$t('settingsPage.cancellationCompensationArrivedRadiusHint')" persistent-hint type="text"
                    style="margin-top: 15px"></v-text-field>

                  <v-switch v-model="cancellationCompensationIncludeCc" :label="$t('settingsPage.cancellationCompensationIncludeCc')"
                    :hint="$t('settingsPage.cancellationCompensationIncludeCcHint')" persistent-hint color="green"
                    style="margin-top: 15px"></v-switch>
                </template>

                <v-btn :loading="loading" block @click="save" color="secondary">{{ $t("settingsPage.save") }}
                </v-btn>
              </v-form>
            </v-flex>
            <!--</v-responsive>-->
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";

// Redenomination (display-only) get/set pair for a money setting stored in
// old-unit SYP: the input shows /100 and writes back via toStoredAmount(), so
// `model` keeps the stored representation (same as welcomeBonusDefaultDisplay).
function storedMoneySetting(key) {
  return {
    get() {
      const v = this.model[key];
      if (v === null || v === undefined || v === '') return '';
      const n = Number(v);
      if (isNaN(n)) return '';
      return n / 100;
    },
    set(value) {
      const stored = this.toStoredAmount(value);
      this.model[key] = stored === null ? '0' : String(stored);
    },
  };
}

export default {
  title() {
    return this.$t("settingsPage.generalTitle");
  },
  name: "GeneralSettings",
  data: () => ({
    loading: false,
    form: false,
    model: {
      CAPTAIN_SUGGESTION_TIME:0,
      MINIMUM_RESERVATION: 0,
      MIN_DISTANCE_TO_PLACE_REQUEST_IN_METERS: 0,
      NORMAL_ALLOWED_WAITING_TIME: 0,
      EXCHANGE_RATE: 0,
      INSTANT_MAX_DISPATCH_DISTANCE: 0,
      DISPATCH_MODE: 'SEQUENTIAL',
      HYBRID_BROADCAST_AFTER: 60,
      DISPATCH_BROADCAST_BATCH_SIZE: 10,
      // Final-version doc 2026-10-05 (dormant): times the same instant order
      // may be offered to a captain who ignored it; '0' = unlimited (today's
      // behaviour). Default mirrors the backend Constants.
      DISPATCH_MAX_NO_RESPONSE_OFFERS: '0',
      // S1: release an order aimed at one specific captain to the normal pool
      // once he does not take it. Default mirrors the backend Constants.
      TARGET_CAPTAIN_FALLBACK: '1',
      INSTANT_TIME_TO_CANCELL: 0,
      RESERVATION_TIME_TO_CANCELL: 0,
      RESERVATION_DISPATCH_START_TIME: 0,
      // QA V4 W1 (#08) reservation reminders / confirmation. Defaults mirror the
      // backend Constants defaults so an unseeded key shows its effective value.
      RESERVATION_REMINDER_CADENCE: '120,60,30,15',
      RESERVATION_CONFIRM_DEADLINE: 20,
      RESERVATION_CONFIRM_REQUIRED: '1',
      RESERVATION_SUGGESTION_TIME: '',
      // QA V4 W7 (#28) upfront pricing. Default OFF to keep current behavior.
      UPFRONT_PRICING_ENABLED: '0',
      EXTRA_KM_TOLERANCE_PCT: 10,
      MAX_FARE_INCREASE_PCT: 25,
      STAGING_ALLOWED_PHONES: '',
      CAPTAIN_MAX_NEGARIVE_AMOUNT: 0,
      SNAP_DRIVE_PHONE: '',
      SNAP_DRIVE_EMAIL: '',
      SNAP_DRIVE_WHATSAPP: '',
      CALL_CENTER_NUMBER: '',
      CAPTAIN_CALL_CENTER_NUMBER: '',
      SAFE_RIDE_ENABLED: '0',
      // Rendered Google Static Maps image in the captain's accept-order
      // window. Default mirrors the backend Constants.
      PROPOSAL_STATIC_MAP_ENABLED: '1',
      // Kill switches of this release, ON by default like the backend
      // Constants: the captain app's live re-route, and the billed-distance
      // guard of the fare.
      CAPTAIN_REROUTE_ENABLED: '1',
      FARE_DISTANCE_GUARD_ENABLED: '1',
      // Owner item 3.1: activity windows (days) of the Active / Inactive
      // filter on the drivers and riders lists. Defaults mirror the backend
      // Constants.
      CAPTAIN_ACTIVITY_WINDOW_DAYS: '30',
      PASSENGER_ACTIVITY_WINDOW_DAYS: '30',
      // Welcome bonus for newly approved captains (doc 28-8). Amount is kept
      // here in the STORED old-unit representation; the display conversion
      // happens in the welcomeBonusDefaultDisplay computed wrapper.
      CAPTAIN_WELCOME_BONUS_ENABLED: '0',
      CAPTAIN_WELCOME_BONUS_DEFAULT: '0',
      // Owner item 2.1 (restricted welcome balance): validity in days and the
      // two money settings in STORED old-unit SYP; '0' = never expires / no
      // ceiling / no second approval.
      CAPTAIN_WELCOME_BONUS_VALIDITY_DAYS: '0',
      CAPTAIN_WELCOME_BONUS_MAX: '0',
      CAPTAIN_WELCOME_BONUS_MATERIALITY: '0',
      // Operational entries doc 2026-10-03 (online payments). Defaults mirror
      // the backend Constants.
      ONLINE_PAYMENT_PENDING_WAIT_MINUTES: '15',
      ONLINE_UNCONFIRMED_CAPTAIN_SETTLE: 'cash',
      UNPAID_ONLINE_RIDE_AFTER_HOURS: '24',
      WALLET_REQUIRE_BALANCE_AT_BOOKING: '0',
      // Accountant doc 2026-10-03 item 1.5: automatic cancellation
      // compensation. Defaults mirror the backend Constants; PER_KM is STORED
      // old-unit SYP (display wrapper below), distances are km.
      CANCELLATION_COMPENSATION_ENABLED: '1',
      CANCELLATION_COMPENSATION_FREE_KM: '2',
      CANCELLATION_COMPENSATION_PER_KM: '2000',
      CANCELLATION_COMPENSATION_ROUNDING: 'floor',
      CANCELLATION_COMPENSATION_MAX_KM: '20',
      CANCELLATION_COMPENSATION_INCLUDE_CC: '0',
      CANCELLATION_COMPENSATION_DISTANCE_TOLERANCE_PCT: '25',
      // Metres: an ARRIVED tap counts as the whole approach only this close
      // to the pickup point.
      CANCELLATION_COMPENSATION_ARRIVED_RADIUS_M: '500'
    },
    originalModel: {},
    isDirty: false,
  }),
  computed: {
    // The backend stores settings as strings ('0'/'1'); the switch wants a
    // boolean, so map both directions here.
    safeRideEnabled: {
      get() {
        return this.model.SAFE_RIDE_ENABLED === '1' || this.model.SAFE_RIDE_ENABLED === 1 || this.model.SAFE_RIDE_ENABLED === true;
      },
      set(value) {
        this.model.SAFE_RIDE_ENABLED = value ? '1' : '0';
      },
    },
    targetCaptainFallback: {
      get() {
        return this.model.TARGET_CAPTAIN_FALLBACK === '1' || this.model.TARGET_CAPTAIN_FALLBACK === 1 || this.model.TARGET_CAPTAIN_FALLBACK === true;
      },
      set(value) {
        this.model.TARGET_CAPTAIN_FALLBACK = value ? '1' : '0';
      },
    },
    proposalStaticMapEnabled: {
      get() {
        return this.model.PROPOSAL_STATIC_MAP_ENABLED === '1' || this.model.PROPOSAL_STATIC_MAP_ENABLED === 1 || this.model.PROPOSAL_STATIC_MAP_ENABLED === true;
      },
      set(value) {
        this.model.PROPOSAL_STATIC_MAP_ENABLED = value ? '1' : '0';
      },
    },
    captainRerouteEnabled: {
      get() {
        return this.model.CAPTAIN_REROUTE_ENABLED === '1' || this.model.CAPTAIN_REROUTE_ENABLED === 1 || this.model.CAPTAIN_REROUTE_ENABLED === true;
      },
      set(value) {
        this.model.CAPTAIN_REROUTE_ENABLED = value ? '1' : '0';
      },
    },
    fareDistanceGuardEnabled: {
      get() {
        return this.model.FARE_DISTANCE_GUARD_ENABLED === '1' || this.model.FARE_DISTANCE_GUARD_ENABLED === 1 || this.model.FARE_DISTANCE_GUARD_ENABLED === true;
      },
      set(value) {
        this.model.FARE_DISTANCE_GUARD_ENABLED = value ? '1' : '0';
      },
    },
    reservationConfirmRequired: {
      get() {
        return this.model.RESERVATION_CONFIRM_REQUIRED === '1' || this.model.RESERVATION_CONFIRM_REQUIRED === 1 || this.model.RESERVATION_CONFIRM_REQUIRED === true;
      },
      set(value) {
        this.model.RESERVATION_CONFIRM_REQUIRED = value ? '1' : '0';
      },
    },
    upfrontPricingEnabled: {
      get() {
        return this.model.UPFRONT_PRICING_ENABLED === '1' || this.model.UPFRONT_PRICING_ENABLED === 1 || this.model.UPFRONT_PRICING_ENABLED === true;
      },
      set(value) {
        this.model.UPFRONT_PRICING_ENABLED = value ? '1' : '0';
      },
    },
    onlineUnconfirmedSettleItems() {
      return [
        { value: 'cash', text: this.$t('settingsPage.onlineUnconfirmedSettleCash') },
        { value: 'refuse', text: this.$t('settingsPage.onlineUnconfirmedSettleRefuse') },
      ];
    },
    walletRequireBalanceAtBooking: {
      get() {
        return this.model.WALLET_REQUIRE_BALANCE_AT_BOOKING === '1' || this.model.WALLET_REQUIRE_BALANCE_AT_BOOKING === 1 || this.model.WALLET_REQUIRE_BALANCE_AT_BOOKING === true;
      },
      set(value) {
        this.model.WALLET_REQUIRE_BALANCE_AT_BOOKING = value ? '1' : '0';
      },
    },
    welcomeBonusEnabled: {
      get() {
        return this.model.CAPTAIN_WELCOME_BONUS_ENABLED === '1' || this.model.CAPTAIN_WELCOME_BONUS_ENABLED === 1 || this.model.CAPTAIN_WELCOME_BONUS_ENABLED === true;
      },
      set(value) {
        this.model.CAPTAIN_WELCOME_BONUS_ENABLED = value ? '1' : '0';
      },
    },
    // Redenomination (display-only): the stored setting is old-unit SYP. This
    // wrapper exposes the new-unit value (/100) to the input and writes back
    // via toStoredAmount(), so `model` always holds the stored representation
    // and save()'s changed-keys diff keeps comparing stored values.
    welcomeBonusDefaultDisplay: {
      get() {
        const v = this.model.CAPTAIN_WELCOME_BONUS_DEFAULT;
        if (v === null || v === undefined || v === '') return '';
        const n = Number(v);
        if (isNaN(n)) return '';
        return n / 100;
      },
      set(value) {
        const stored = this.toStoredAmount(value);
        this.model.CAPTAIN_WELCOME_BONUS_DEFAULT = stored === null ? '0' : String(stored);
      },
    },
    // Owner item 2.1: the ceiling and the materiality threshold are old-unit
    // money like the default above, with the same display wrapper.
    welcomeBonusMaxDisplay: storedMoneySetting('CAPTAIN_WELCOME_BONUS_MAX'),
    welcomeBonusMaterialityDisplay: storedMoneySetting('CAPTAIN_WELCOME_BONUS_MATERIALITY'),
    cancellationCompensationEnabled: {
      get() {
        return this.model.CANCELLATION_COMPENSATION_ENABLED === '1' || this.model.CANCELLATION_COMPENSATION_ENABLED === 1 || this.model.CANCELLATION_COMPENSATION_ENABLED === true;
      },
      set(value) {
        this.model.CANCELLATION_COMPENSATION_ENABLED = value ? '1' : '0';
      },
    },
    cancellationCompensationIncludeCc: {
      get() {
        return this.model.CANCELLATION_COMPENSATION_INCLUDE_CC === '1' || this.model.CANCELLATION_COMPENSATION_INCLUDE_CC === 1 || this.model.CANCELLATION_COMPENSATION_INCLUDE_CC === true;
      },
      set(value) {
        this.model.CANCELLATION_COMPENSATION_INCLUDE_CC = value ? '1' : '0';
      },
    },
    cancellationCompensationPerKmDisplay: storedMoneySetting('CANCELLATION_COMPENSATION_PER_KM'),
    compensationRoundingItems() {
      return [
        { text: this.$t('settingsPage.cancellationCompensationRoundingFloor'), value: 'floor' },
        { text: this.$t('settingsPage.cancellationCompensationRoundingProrata'), value: 'prorata' },
      ];
    },
    // rules live in computed (not data) so validation messages re-resolve on locale switch
    rules() {
      return {
        email: (v) => !!(v || "").match(/@/) || this.$t("settingsPage.ruleEmail"),
        length: (len) => (v) =>
          (v || "").length >= len || this.$t("settingsPage.ruleLength", { len }),
        required: (v) => !!v || this.$t("settingsPage.ruleRequired"),
        number: (v) => /^\d+(\.\d+)?$/.test(v) || this.$t("settingsPage.rulePositiveNumber"),
        // Optional positive number: empty is allowed (falls back server-side).
        numberOrEmpty: (v) =>
          v === "" || v === null || v === undefined || /^\d+(\.\d+)?$/.test(v) || this.$t("settingsPage.rulePositiveNumber"),
        // CSV of positive numbers, e.g. "120,60,30,15" (empty allowed).
        csvNumbers: (v) =>
          !v || /^\s*\d+(\.\d+)?(\s*,\s*\d+(\.\d+)?)*\s*$/.test(v) || this.$t("settingsPage.ruleCsvNumbers"),
        // A whole number of days, at least 1 (activity windows).
        wholeDays: (v) => /^[1-9]\d*$/.test(String(v)) || this.$t("settingsPage.ruleWholeDays"),
        // A whole number, 0 allowed (welcome balance validity: 0 = never expires).
        wholeNumber: (v) => /^\d+$/.test(String(v)) || this.$t("settingsPage.ruleWholeNumber"),
        phone: (v) => !v || /^\+?\d[\d\s-]*$/.test(v) || "Must be a valid phone number",
      };
    },
  },
  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    axios.get("setting").then((response) => {
      // QA V3 #16: copy ONLY the keys this tab declares. Object.assign used
      // to absorb the FULL settings map (~60 keys) into `model`, and save()
      // then PUT them all back — replaying this tab's page-load snapshot over
      // every setting edited elsewhere since ("settings randomly revert").
      const data = response.data.data || {};
      Object.keys(this.model).forEach((key) => {
        if (key in data) this.model[key] = data[key];
      });
      this.originalModel = JSON.parse(JSON.stringify(this.model));

    });
  },
  beforeDestroy() {
    // alert("beforeDestroy");
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  watch: {
    model: {
      handler(newVal, oldVal) {
        if (Object.keys(this.originalModel).length > 0) {
          this.isDirty = JSON.stringify(newVal) !== JSON.stringify(this.originalModel);
        }
      },
      deep: true,
      immediate: false
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.isDirty) {
      const answer = confirm(this.$t("settingsPage.unsavedChanges"));
      if (answer) {
        next(); // User confirmed, allow navigation
      } else {
        next(false); // User canceled, prevent navigation
      }
    } else {
      next(); // No unsaved changes, allow navigation
    }

  },
  methods: {
    handleBeforeUnload(event) {
      if (this.isDirty) {
        event.preventDefault();
        event.returnValue = this.$t("settingsPage.unsavedChanges");
      }
    },

    save() {
      if (!this.$refs.form.validate()) {
        window.getApp.$emit(
          "SHOW_TOAST",
          this.$t("settingsPage.enterValidValues"),
          "red"
        );
        return;
      }


      // QA V4 W5 (#25): PUT only the keys that actually changed since load, so a
      // concurrent edit to another key by another admin is not clobbered by this
      // tab's page-load snapshot.
      const changed = {};
      Object.keys(this.model).forEach((key) => {
        if (JSON.stringify(this.model[key]) !== JSON.stringify(this.originalModel[key])) {
          changed[key] = this.model[key];
        }
      });

      if (Object.keys(changed).length === 0) {
        window.getApp.$emit("SHOW_TOAST", this.$t("settingsPage.settingsSaved"));
        this.isDirty = false;
        return;
      }

      this.loading = true;

      this.axios
        .put(`setting/update`, changed)
        .then(() => {
          window.getApp.$emit("SHOW_TOAST", this.$t("settingsPage.settingsSaved"))
          this.originalModel = JSON.parse(JSON.stringify(this.model));
          this.isDirty = false;
        })
        .catch(({ response }) => {
          window.getApp.$emit("SHOW_TOAST", this.$t("settingsPage.failedSaveSettings"), "red");
          console.log(response);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>
